import React from 'react';

import { PolicyIcon } from 'components/Icons';
import { BlueprintDetailCard } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/BlueprintDetailCard';
import { useBlueprintsContext } from 'containers/PolicyHub/Blueprints/hooks/context';

export const Policies: React.FC = () => {
  const { setShowPolicies } = useBlueprintsContext();
  return (
    <BlueprintDetailCard
      icon={<PolicyIcon p={0.5} />}
      label="Policies"
      onClick={() => setShowPolicies(true)}
    />
  );
};
